/* eslint-disable @atlassian/relay/must-use-inline, @atlassian/relay/graphql-naming, @atlassian/relay/unused-fields -- Shared resource operations and canonical snapshots are consumed by the resource owner, readers, and store reconciliation. */
import { graphql } from 'react-relay';
import type { GraphQLTaggedNode } from 'relay-runtime';

export const agentSessionSnapshot: GraphQLTaggedNode = graphql`
	fragment agentSessionSnapshot_session on AgentSession {
		...agentSessionCore_session @relay(mask: false)
		agent {
			accountId
			name
			picture
		}
		author {
			accountId
			name
		}
		studioAgent {
			name
		}
		associatedEntities {
			__typename
			... on JiraIssue {
				id
				key
				webUrl
			}
			... on ConfluencePage {
				id
				title
				links {
					base
					webUi
				}
			}
		}
	}
`;
